import { rootStateBranchSelector } from 'shared/utils/rootStateBranchSelector';

export const rsSelector = rootStateBranchSelector('rs');
